import useAuth from "@/hooks/useAuth";
import { Circle } from "@mui/icons-material";
import {
    Chip,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer
  } from "@mui/material";
import { useAuthenticationsRequest } from "apiRequests/usersAuthentications";
import { User } from "lucide-react";
import {DateTime} from "luxon";

const Authentications = () => {
    const {user} = useAuth()
    const { data, loading, error } = useAuthenticationsRequest(user)

    console.log("Authentications data", data, loading, error)
    return (
        <Paper>
            <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
                <Table stickyHeader style={{ minWidth: 800 }}>
                <TableHead>
                    <TableRow>
                        <TableCell>User</TableCell>
                        <TableCell >IP Address</TableCell>
                        <TableCell>Location</TableCell>
                        <TableCell>Attempt At</TableCell>
                        <TableCell>Attempt Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.map((row) =>{
                        let color : "color" | "success" | "error" = "success"
                        if(row.success){
                            color = "success"
                        }else{
                            color = "error"
                        }
                        const status = row.success ? "success" : "failed"
                        const locs :string[] = []
                        for(const location of row?.locations || []){ 
                            let loc: string[] = []
                            if(location?.city) loc.push(location?.city)
                            if(location?.country) loc.push(location?.country)
                            if(location?.latitude) loc.push(location?.latitude.toString())
                            if(location?.longitude) loc.push(location?.longitude.toString())
                            
                            locs.push(loc.join(", "))
                        }
                        return  (
                            <TableRow key={row.id}>
                                <TableCell>
                                    <div style={{float: "left", display: "flex", width: "3em", height: "3em", borderRadius: "50%", backgroundColor: "#efefef", alignItems: "center", justifyContent: "center"}}>
                                        <User color="#aabbff" />
                                    </div>
                                    <div style={{verticalAlign: "middle", paddingLeft: 60}}>
                                        <div>
                                            {row.firstName}&nbsp;{row.lastName}
                                        </div>
                                        {row.email}
                                    </div>
                                </TableCell>
                                <TableCell>{row.ipAddress.split("|").filter((a)=>a).join(" > ")}</TableCell>
                                <TableCell>
                                    {locs.length != 0 ? locs.join(" > ") : "N/A"}
                                </TableCell>
                                <TableCell>{DateTime.fromISO(row.createdAt).toFormat("h:mma - d LLL yyyy")}</TableCell>
                                <TableCell>
                                    <Chip label={<div><Circle style={{fontSize: 8, verticalAlign: "middle"}} /> {status}</div>} color={color} size="small" style={{borderRadius: 15}} variant="outlined" />
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}
export default Authentications;